/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Row, TextField, TEXTFIELD_TYPE_TEXTAREA, TextFieldProps } from '@squiz/sds';
import { AI_STRINGS } from 'apps/artificial-intelligence/src/Constants/Strings.constants';
import React, { ChangeEvent, useId, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSemanticAuditorTestBuilderStore } from '../../SemanticAuditorTestBuilder.state';

export const SemanticAuditorTestBasicInfo = (): JSX.Element => {
  const id = useId();
  const { t } = useTranslation();
  const labels = {
    description: t(AI_STRINGS.description),
    name: t(AI_STRINGS.name),
    requiredField: t(AI_STRINGS.requiredField),
  };
  const { name, setName, description, setDescription, nameError } = useSemanticAuditorTestBuilderStore();
  const nameFieldProps: TextFieldProps = {
    classes: 'semantic-auditor-test-basic-info__name',
    errorMessage: nameError ? labels.requiredField : undefined,
    fieldLabel: labels.name,
    id: `name-${id}`,
    name: labels.name,
    onChange: (e: ChangeEvent<HTMLInputElement>) => setName(e.target.value),
    required: true,
    value: name,
  };
  const nameRef = useRef<HTMLInputElement>(null);
  const descriptionFieldProps: TextFieldProps = {
    classes: 'semantic-auditor-test-basic-info__description',
    fieldLabel: labels.description,
    id: `description-${id}`,
    name: labels.description,
    onChange: (e: ChangeEvent<HTMLInputElement>) => setDescription(e.target.value),
    rows: 2,
    type: TEXTFIELD_TYPE_TEXTAREA,
    value: description,
  };
  const descriptionRef = useRef<HTMLInputElement>(null);
  return (
    <Row border={false} classes="semantic-auditor-test-basic-info">
      <TextField {...nameFieldProps} ref={nameRef} />
      <TextField {...descriptionFieldProps} ref={descriptionRef} />
    </Row>
  );
};
